<div class="footer no-print bg-black text-white pt-2">
  <span>
    Developed by PavCon, LLC. &#169; {{ year }}. All Rights Reserved |
    {{ version }}</span>
</div>